import { z } from "zod";

export const ChecklistEntregaCopiaSchema = z.object({
    idChecklistEntrega: z.number().int().optional(),
    codigo: z.string().nonempty({ message: "O código é obrigatório." }),
    descricao: z.string().nonempty({ message: "A descrição é obrigatória." }),
    revisao: z.string().nonempty({ message: "A revisão é obrigatória." }),

});

export type ChecklistEntregaCopiaForm = z.infer<typeof ChecklistEntregaCopiaSchema>;

export const defaultChecklistEntregaCopiaForm: Partial<ChecklistEntregaCopiaForm> = {
    idChecklistEntrega: undefined,
    codigo: undefined,
    descricao: undefined,
    revisao: undefined,


};
